import React from 'react';
export function GuaranteeSection() {
  return <section className="py-[70px] px-5 bg-cream-dark text-center reveal" data-id="element-129">
      <div className="max-w-[560px] mx-auto bg-white rounded-2xl py-10 px-9 shadow-[0_4px_32px_rgba(30,45,36,0.08)] relative sm:py-7 sm:px-5" data-id="element-130">
        <div className="text-[3rem] mb-4" data-id="element-131">🛡️</div>
        <h2 className="font-playfair text-[1.6rem] font-bold text-text-dark mb-4" data-id="element-132">
          Garantía Blindaje Emocional
        </h2>
        <p className="font-lora text-[0.95rem] text-text-mid leading-[1.8] italic mb-3.5" data-id="element-133">
          Si aplicás el sistema durante los 21 días completos y no ves un cambio
          en la actitud de tu hijo hacia la lectura — más predisposición, menos
          resistencia, más confianza — te devolvemos el 100% de tu dinero. Sin
          preguntas incómodas.
        </p>
        <div className="text-[0.82rem] text-forest font-medium" data-id="element-134">
          Queremos que tu única preocupación sea disfrutar el proceso con tu
          hijo.
        </div>
      </div>
    </section>;
}